import React from 'react'
import { Box, Typography, Paper, Button } from '@mui/material'
import { Block } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { Layout } from '@/components/Layout'
import { useAuth } from '@/contexts/AuthContext'

export default function Unauthorized() {
  const { signOut } = useAuth()

  const handleSignOut = async () => {
    await signOut()
  }

  return (
    <Layout showNavigation={false}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '70vh',
          px: 2,
        }}
      >
        <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: '100%', textAlign: 'center' }}>
          <Block color="error" sx={{ fontSize: 64, mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            You don't have permission to access this page. Please contact support if you believe this is an error.
          </Typography>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Button variant="contained" fullWidth component={Link} to="/">
              Go to Home
            </Button>
            
            <Button 
              variant="outlined" 
              fullWidth 
              onClick={handleSignOut}
            >
              Sign Out
            </Button>
          </Box>
        </Paper>
      </Box>
    </Layout>
  )
}